import { combineReducers } from 'redux';
import { createReducer } from 'redux-act';
import { createSelector } from 'reselect';
import { createResource } from '@gandi/resource/redux';
import { toQueryParameter, statePath as moduleStatePath, baseUrl as moduleBaseUrl } from '../../utils';
import { selectRaw as moduleSelectRaw } from '../common';
export const statePath = `${moduleStatePath}.simplehosting.disks`;
const baseUrl = `${moduleBaseUrl}/paas`;
export const resource = createResource('prices.simplehosting.disks');
const initialPricesState = () => ({});
const initialTaxesState = () => [];
const convertApiPriceToState = price => {
  const diskPrice = {
    maxDuration: price.max_duration,
    minDuration: price.min_duration,
    durationUnit: price.duration_unit,
    discount: price.discount,
    price: price.price,
    priceBeforeTaxes: price.price_before_taxes,
    priceAfterTaxes: price.price_after_taxes,
    features: price.features
  };
  if ('normal_price_before_taxes' in price) {
    diskPrice.normalPriceBeforeTaxes = price.normal_price_before_taxes;
  }
  if ('normal_price_after_taxes' in price) {
    diskPrice.normalPriceAfterTaxes = price.normal_price_after_taxes;
  }
  return diskPrice;
};
const diskPricesReducer = createReducer({
  [resource.fetch.success.getType()]: (state, payload) => payload.response.data.products.reduce((acc, product) => ({
    ...acc,
    [product.process]: product.prices.map(convertApiPriceToState)
  }), state)
}, initialPricesState());
const diskTaxesReducer = createReducer({
  [resource.fetch.success.getType()]: (state, payload) => payload.response.data.products.reduce((acc, product) => product.taxes || [], [])
}, initialTaxesState());
export default combineReducers({
  disks: diskPricesReducer,
  taxes: diskTaxesReducer
});
const selectProcessProp = (state, props) => props?.process || 'create';
const selectRaw = state => moduleSelectRaw(state).simplehosting.disks;
const selectRawTaxes = state => selectRaw(state).taxes;
const selectRawPrices = state => selectRaw(state).disks;
export const selectIsLoaded = state => resource.selectIsLoaded(state, 'default');
export const selectIsFetching = state => resource.selectIsFetching(state, 'default');
export const selectIsFailure = state => resource.selectIsFailure(state, 'default');
export const selectIsToRefetch = state => resource.selectIsToRefetch(state, 'default');
export const selectPrice = createSelector(selectRawPrices, selectProcessProp, (pricesState, process) => pricesState[process]?.[0]);
export const selectTaxesApply = createSelector(selectRawTaxes, taxes => Array.isArray(taxes) && taxes.filter(tax => tax.name !== 'notax').length > 0);
export const fetchAll = props => dispatch => dispatch(resource.fetch(`${baseUrl}?${toQueryParameter({
  name: 'disk',
  features: 'true',
  processes: 'create',
  ...props
})}`, {
  on200: response => {
    if (response.data.status === 'error' || !Array.isArray(response.data.products)) {
      return Promise.reject(response);
    }
    return response;
  },
  not200: response => Promise.reject(response)
}));
export const abort = () => resource.fetch.failure({
  err: new Error('Aborted')
});